package one.healthium.health_log.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.unit.dp
import one.healthium.domain.health_log.models.HealthLogAnswerModel
import one.healthium.domain.health_log.models.HealthLogQuestionModel
import one.healthium.health_log.ui.models.HealthLogQuestionUiModel
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_7
import androidx.compose.ui.tooling.preview.Preview

@Composable
fun HealthLogQuestionItem(
    modifier: Modifier = Modifier,
    model: HealthLogQuestionUiModel,
    onOptionSelected: (HealthLogAnswerModel) -> Unit,
) {
    Column(
        modifier = modifier,
    ) {
        Text(
            text = model.kind,
            style = AppTheme.textStyles.secondary_16_700,
            color = AppTheme.colors.text400,
        )
        if (model.question != null && model.question.isNotEmpty()) {
            Spacer(Modifier.height(4.dp))
            Text(
                text = model.question,
                style = AppTheme.textStyles.secondary_16_500,
                color = AppTheme.colors.text400,
                fontStyle = FontStyle.Italic,
            )
        }
        Spacer(Modifier.height(12.dp))
        FlowRow(
            modifier = Modifier
                .fillMaxWidth()
                .background(
                    color = gray_7,
                    shape = AppTheme.shapes.small,
                )
                .padding(horizontal = 12.dp, vertical = 24.dp),
            horizontalArrangement = Arrangement.spacedBy(12.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            model.options.forEach { option ->
                val isSelected = model.selectedOption?.id == option.id
                Box(
                    modifier = Modifier
                        .clip(RoundedCornerShape(6.dp))
                        .clickable { onOptionSelected(option) }
                        .background(
                            color = if (isSelected) {
                                AppTheme.colors.primary
                            } else {
                                AppTheme.colors.surface
                            },
                        )
                        .defaultMinSize(minHeight = 34.dp)
                        .padding(horizontal = 12.dp, vertical = 6.dp),
                    contentAlignment = Alignment.Center,
                ) {
                    Text(
                        text = option.text,
                        style = AppTheme.textStyles.secondary_14_500,
                        color = if (isSelected) {
                            AppTheme.colors.onPrimary
                        } else {
                            AppTheme.colors.onSurface
                        }
                    )
                }
            }
        }
    }
}

@Composable
@Preview(showBackground = true)
private fun HealthLogQuestionItemPreview() {
    AppTheme {
        HealthLogQuestionItem(
            model = HealthLogQuestionUiModel(
                model = HealthLogQuestionModel.preview,
                selectedOption = HealthLogQuestionModel.preview.answers.firstOrNull(),
            ),
            onOptionSelected = {}
        )
    }
}